import { TextField } from '@components/base/inputs';
import { VStack } from '@components/base/layout';
import { Text } from '@components/base/display';
import { RepeatableTextInput } from './RepeatableTextInput';

interface CallAiAgentConfigPanelProps {
  readonly getValue: (field: string) => unknown;
  readonly setValue: (field: string, value: unknown) => void;
}

export function CallAiAgentConfigPanel({
  getValue,
  setValue,
}: Readonly<CallAiAgentConfigPanelProps>) {
  return (
    <VStack gap={4}>
      <TextField
        label="Agent Slug"
        required
        placeholder="e.g. claim-analyzer"
        value={(getValue('config_agent_slug') as string) ?? ''}
        onChange={(e) => setValue('config_agent_slug', e.target.value)}
      />

      <VStack gap={1}>
        <Text as="label" size="sm" weight="medium">
          Prompt Template *
        </Text>
        <textarea
          className="w-full rounded-md border border-neutral-300 px-3 py-2 text-sm focus:border-primary-500 focus:outline-none focus:ring-1 focus:ring-primary-500"
          rows={4}
          placeholder="e.g. Analyze the following claim: {{claim_data}}"
          value={(getValue('config_prompt_template') as string) ?? ''}
          onChange={(e) => setValue('config_prompt_template', e.target.value)}
        />
        <Text size="xs" color="muted">
          Use {'{{context_key}}'} syntax for dynamic values from the workflow
          context.
        </Text>
      </VStack>

      <RepeatableTextInput
        label="Input Keys"
        placeholder="e.g. claim_data"
        helperText="Context keys to pass as input to the AI agent."
        value={(getValue('config_input_keys') as string[]) ?? []}
        onChange={(value) => setValue('config_input_keys', value)}
      />

      <TextField
        label="Output Key"
        placeholder="ai_response"
        helperText="Context key where the AI response will be stored. Defaults to 'ai_response'."
        value={(getValue('config_output_key') as string) ?? ''}
        onChange={(e) => setValue('config_output_key', e.target.value)}
      />
    </VStack>
  );
}
